import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {FilesService} from './files.service';
import {AuthService} from '../../../core/service/auth.service';
import {DatesParserService} from '../../../core/service/dates_parser.service';
import {File} from './model/file';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Subscription} from 'rxjs/Subscription';
import {FileDownloadService} from '../../../shared/components/file_download/file_download.service';

import Swal from 'sweetalert2';
import * as _ from 'underscore';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import {RazonSocialService} from '../../../shared/service/razon-social.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html'
})
export class FilesComponent implements OnInit {

  private campType: string;
  files: Array<File>;
  sales: Array<Object>;
  temp: Array<File> = [];
  enabled: boolean;
  formSearch: FormGroup;
  // iniDate: string;
  iniDate: Date;
  endDate: Date;
  filenameSearch: string;
  generationType: string;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(private filesSrv: FilesService, private authService: AuthService, private datesParser: DatesParserService,
              private fileDownload: FileDownloadService, private activatedRoute: ActivatedRoute) {
    this.files = [];
    this.enabled = false;
    this.filenameSearch = '';
    this.generationType = '';
    this.sales = this.authService.getSales();

    this.fileDownload.getSubject().asObservable().subscribe(
      (msg) => {
        Swal('File download error', msg, 'error');
      }
    );

    this.formSearch = new FormGroup(
      {
        'start_date': new FormControl(),
        'end_date': new FormControl(),
        'campaign': new FormControl()
      }
    );
    this.iniDate = new Date();
    this.iniDate.setHours(0, 0, 0, 0);

    this.endDate = new Date();
    this.endDate.setHours(23, 59, 59, 0);
  }

  /**
   * Finds files for list
   */
  findFiles() {
    this.enabled = true;
    const queryDates: Object = this.datesParser.cleanDates(this.formSearch.value, ['start_date', 'end_date']);
    const query = Object.assign({}, {'camp_type': this.campType, 'generation_type': this.generationType}, queryDates);
    this.filesSrv.findFiles(query).subscribe(
      data => {
        this.files = data;
        this.temp = [...data];
        this.enabled = false;
      }
    );
  }

  /**
   * Updates event for table search
   * @param event
   */
  updateFilter(event) {
    this.filenameSearch = event.target.value.toLowerCase();
    const temp = this.temp.filter((d) => {
      return d.name.toLowerCase().indexOf(this.filenameSearch) !== -1 || !this.filenameSearch;
    });

    this.files = temp;
    this.table.offset = 0;
  }

  /**
   * Change campaign select event
   */
  changeCampaign() {
    const camp = _.find(
      this.sales,
      o => o['pk'] === this.formSearch.value.campaign
    );

    if (camp) {
      this.campType = camp['etype'];
    }
  }

  /**
   * inits component
   */
  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Object) => {
        this.enabled = true;
        this.generationType = params['gtype'];
        const query = {'generation_type': this.generationType};
        this.filesSrv.findFiles(query).subscribe(
          data => {
            this.files = data;
            this.temp = [...data];
            this.enabled = false;
          }
        );
      }
    );
  }
};



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files/files.component.ts